
const state = {
  show: false,
  driversInfo: {}
}

const actions = {
  updateDrivers (ctx, item) {
    ctx.commit('updateDrivers', item)
  }
}

const mutations = {
  updateDrivers (state, item) {
    state.driversInfo = item
  },
  showUpdateDrivers (state, item) {
    state.show = item
  }
}

export default{
  namespaced: true,
  state,
  actions,
  mutations
}
